import React, { useEffect, useState } from 'react'
import Header from '../Header/Header';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import logo from '../../assets/logo.png';
import { useNavigate } from 'react-router-dom';

const Completion = () => {
    const [ticketData, setTicketData] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        const dataFromStorage = localStorage.getItem('ticketData');
        if (dataFromStorage) {
          setTicketData(JSON.parse(dataFromStorage));
          localStorage.removeItem('ticketData'); 
        }

        console.log(ticketData)
      }, []);



      useEffect(() => {
       
        const handleBeforeUnload = (event) => {
          navigate('/');
          event.preventDefault();
          event.returnValue = '';
        };
    
        window.addEventListener('beforeunload', handleBeforeUnload);
    
        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
        };
      }, [navigate]);



  return (
    <div>
        <div className='header-container-payment'>
            <Header/>
        </div>
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",height:"100vh", marginTop:"5em"}}>
        <h1>Thank you! 🎉</h1>
        <h4>Tickets Purchased: Qty {ticketData.numberOfTickets}</h4>
        <h4>TicketCode: {ticketData.ticketCode}</h4>
        <img style={{width:"20vw",margin:"3em 0em"}} src={ticketData.qrCode} alt='qrCode' />
        <h3>Ticket details and reciept of the ticket has been sent to your registered email. Emails can go to your spam folder.  </h3>
    </div>
    <div style={{marginTop:"-8em"}} className="footer"> 
            <div className="footer-info">
                <img src={logo}/>
                <h3>Discover upcoming events in your town: Your go-to online destination for staying updated with the latest happenings.</h3>
            </div>
            <hr className="line"/>
           <h4 className="copyright">Made with <FontAwesomeIcon style={{color:"red"}} icon={faHeart} /> by Sekh Mohammad Irfan </h4>
      </div>
    </div>
    
  )
}

export default Completion